import React from 'react';
import PropTypes from 'prop-types';
import { X, Check } from '@wix/wix-ui-icons-common';

import IconButton from '../IconButton';
import { DataHooks } from './constants';
import { classes } from './ColorPickerActions.st.css';

const ColorPickerActions = ({ onCancel, onConfirm, disabled }) => (
  <div className={classes.root}>
    <IconButton
      dataHook={DataHooks.cancelButton}
      size="medium"
      priority="secondary"
      onClick={onCancel}
    >
      <X />
    </IconButton>
    <IconButton
      dataHook={DataHooks.confirmButton}
      size="medium"
      disabled={disabled}
      onClick={onConfirm}
    >
      <Check />
    </IconButton>
  </div>
);

ColorPickerActions.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ColorPickerActions;
